export default __webpack_public_path__ + "static/how_it_works_1-1d2fffa8822fe48437157e198dcb6ede.png";